import React from 'react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLinkedin,
  faInstagram,
  faFacebook,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <h3 className="footer-logo">Safe Dose</h3>
              <p>
                Especialistas em soluções completas para controle de qualidade e
                proteção radiológica para radiodignóstico. Atendemos
                profissionais de saúde e instituições em todo o Brasil.
              </p>
              <div className="social-icons">
                <a
                  href="https://www.instagram.com/safedose.protecao.radiologica/s"
                  className="social-icon"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a
                  href="https://www.instagram.com/safedose.protecao.radiologica/s"
                  className="social-icon"
                >
                  <FontAwesomeIcon icon={faLinkedin} />
                </a>
                <a
                  href="https://www.instagram.com/safedose.protecao.radiologica/s"
                  className="social-icon"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h3>Links Rápidos</h3>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/services">Serviços</Link>
                </li>
                <li>
                  <Link to="/contact">Contato</Link>
                </li>
                {/* <li><a href="#">Blog</a></li> */}
                {/* <li>
                  <a href="#">Perguntas Frequentes</a>
                </li> */}
              </ul>
            </div>

            <div className="footer-services">
              <h3>Nossos Serviços</h3>
              <ul>
                <li>
                  <Link to="/services#cq">Controle de Qualidade</Link>
                </li>
                <li>
                  <Link to="/services#licensing">
                    Licenciamento ANVISA/CNEN
                  </Link>
                </li>
                <li>
                  <Link to="/services#tests">Testes de Aceitação</Link>
                </li>
                <li>
                  <Link to="/services#qa">Garantia da Qualidade</Link>
                </li>
                <li>
                  <Link to="/services#supervision">Supervisão em Proteção</Link>
                </li>
                <li>
                  <Link to="/services#training">
                    Treinamento em Radioproteção
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-contact">
              <h3>Contato</h3>
              <ul className="contact-info">
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>
                    Quadra 501 Sul. Av. NS-A, Conjunto 02 Lote 10, s/n - Plano
                    Diretor Sul
                    <br />
                    Palmas - TO, 77016-008
                  </span>
                </li>
                <li>
                  <i className="fas fa-phone-alt"></i>
                  <span>(62) 98227-0793</span>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <span>rubens@safedose.com.br</span>
                </li>
                <li>
                  <i className="fas fa-clock"></i>
                  <span>Segunda a Sexta: 8h às 18h</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} Safe Dose. Todos os direitos
            reservados.
          </p>
          <div className="footer-bottom-links">
            <a href="#">Política de Privacidade</a>
            <a href="#">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
